function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    information: null,
    informationTemplate: null,
    consentsTemplate: null,
    globalConsentsTemplate: [],
    organizationMemberships: [],
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.CHECK_INFORMATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.CHECK_INFORMATION),
                    errors: unregisterAction(state.errors, actionTypes.CHECK_INFORMATION)
                });
            }
        case actionTypes.CHECK_INFORMATION_SUCCESS:
            {
                const { information, informationTemplate, consentsTemplate, globalConsentsTemplate } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    information,
                    informationTemplate,
                    consentsTemplate,
                    globalConsentsTemplate,
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_INFORMATION)
                });
            }
        case actionTypes.CHECK_INFORMATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_INFORMATION),
                    errors: registerAction(state.errors, actionTypes.CHECK_INFORMATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CONSENTS_TEMPLATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        case actionTypes.FETCH_CONSENTS_TEMPLATE_SUCCESS:
            {
                const { consentsTemplate, globalConsentsTemplate } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    consentsTemplate,
                    globalConsentsTemplate,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        case actionTypes.FETCH_CONSENTS_TEMPLATE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CONSENTS_TEMPLATE),
                    errors: registerAction(state.errors, actionTypes.FETCH_CONSENTS_TEMPLATE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_INFORMATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_INFORMATION),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_INFORMATION)
                });
            }
        case actionTypes.UPDATE_INFORMATION_SUCCESS:
            {
                const { informationUpdate } = action.payload;
                const information = _object_spread({}, state.information, informationUpdate);
                return _object_spread_props(_object_spread({}, state), {
                    information,
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_INFORMATION)
                });
            }
        case actionTypes.UPDATE_INFORMATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_INFORMATION),
                    errors: registerAction(state.errors, actionTypes.UPDATE_INFORMATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.CHECK_ORGANIZATION_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
